export default __webpack_public_path__ + "static/media/poster_02_march.d436bd26.png";